import React, { useState, memo, useRef } from 'react';

function ProductCard({ product, addToCart }) {
  const [isAdding, setIsAdding] = useState(false);
  const cardRef = useRef(null);
  const buttonRef = useRef(null);

  const handleAddToCart = (e) => {
    setIsAdding(true);
    setTimeout(() => setIsAdding(false), 1500);

    const cartIcon = document.querySelector('.cart-icon');
    if (cartIcon && buttonRef.current) {
      const clone = document.createElement('img');
      clone.src = '/icons/cart.svg';
      clone.className = 'cart-fly';
      document.body.appendChild(clone);

      const buttonRect = buttonRef.current.getBoundingClientRect();
      const cartRect = cartIcon.getBoundingClientRect();

      clone.style.left = `${buttonRect.left + buttonRect.width / 2}px`;
      clone.style.top = `${buttonRect.top + buttonRect.height / 2}px`;

      setTimeout(() => {
        clone.className = 'cart-fly fly';
        clone.style.left = `${cartRect.left + cartRect.width / 2}px`;
        clone.style.top = `${cartRect.top + cartRect.height / 2}px`;
        clone.style.transform = 'scale(0.5)';
        clone.style.opacity = '0';
      }, 300);

      setTimeout(() => {
        document.body.removeChild(clone);
      }, 1500);
    }

    addToCart(product);
  };

  return (
    <div className={`product-card ${isAdding ? 'adding' : ''}`} ref={cardRef}>
      <img src={product.image} alt={product.name || 'Изображение не найдено'} loading="lazy" onError={(e) => { e.target.src = '/images/not-found.png'; }} />
      <h3>{product.name}</h3>
      <p>{product.price} ₽</p>
      <button ref={buttonRef} onClick={handleAddToCart}>
        Добавить в заказ
      </button>
    </div>
  );
}

export default memo(ProductCard);